import React from "react";
import styled, {keyframes} from "styled-components";
import {fadeIn} from 'react-animations';


const TutorialsContainer = () => {

return(


      <CoolStuffContainer>
        <VideoContainer>
        <iframe
            title="project 1"
            width="600vw"
            height="400vw"
            src="https://www.youtube.com/embed/zYlmoMW_wZg?rel=0&amp;controls=0&amp;showinfo=0"
            frameBorder="0" allowFullScreen = {false}>
        </iframe>
            <VideoText align="center" >
                Papi Bird 360
            </VideoText>
        </VideoContainer>
        <VideoContainer>
          <iframe
              title="project 2"
              width="600vw"
              height="400vw"
              src="https://www.youtube.com/embed/gcg2uw8mhcU?rel=0&amp;controls=0&amp;showinfo=0&amp;start=23"
              frameBorder="0"
              allowFullScreen = {false}>
          </iframe>
          <VideoText  align="center" >
            Build Up AR
          </VideoText>
        </VideoContainer>
        <VideoContainer>

          <iframe
                  title="project 3"
                  width="600vw"
                  height="400vw"
                  src="https://www.youtube.com/embed/SSnjEpN43Jc?rel=0&amp;controls=0&amp;showinfo=0"
                  frameBorder="0"
                  allowFullScreen = {false}>
          </iframe>
              <VideoText align="center" >
                US Bills AR
              </VideoText>
        </VideoContainer>
        <VideoContainer>
          <iframe
                  title="project 3"
                  width="600vw"
                  height="400vw"
                  src="https://www.youtube.com/embed/64ztzc4qHco?rel=0&amp;controls=0&amp;showinfo=0"
                  frameBorder="0"
                  allowFullScreen = {false}>
          </iframe>
              <VideoText align="center" >
                Anatomy AR+
              </VideoText>
        </VideoContainer>
      </CoolStuffContainer>





  )

}


const fadeInanimation = keyframes`${fadeIn}`;

const TutsContainer = styled.div`
    background-color: #000;
    height: 100%;
    padding-bottom:70px;

`;


const CoolStuffContainer = styled.div`
     display: flex;
     flex-wrap: wrap;
     justify-content: space-around;
     background-color: #000;
     padding-bottom:20px;
`;

const VideoContainer = styled.div`
  display:flex;
  flex-direction:column;
  color:white;
  width: 43vw;
  margin-top: 3vw;
  background: rgba(45,45,45,0.5);
  border-radius: 10px;
  justify-content:center;
  align-items:center;
`;

const VideoText = styled.div`
  color: #fff;
  font-family: "Helvetica Neue", sans-serif;
  font-weight: lighter;
  font-size: 1.2vw;
  letter-spacing: .1vw;
  text-align: center;
  height: 7vw;
  display: flex;
  align-items: center;
  width:100%;
  justify-content: center;
`;

const ProjectsText = styled.h1`
        color: #fff;
        font-family: "Helvetica Neue", sans-serif;
        font-weight: lighter;
        font-size: 2.5vw;
        letter-spacing: .2vw;
        animation: ${fadeInanimation} .3s ease-in-out;
        margin-bottom: 5vw;
        margin-top: ${props=> props.marginTop};
        text-align:center;
        `;


const Line = ({width})=> { return( <svg height=".8vw" width="20vw">
                              <line x1="0" y1="0" x2={width} y2="0" style={{stroke:'#fff', strokeWidth:2}} />
                           </svg> )} ;


export default TutorialsContainer;



// WEBPACK FOOTER //
// ./src/components/TutorialsContainer.js